import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  GET_PRODUTOS_BEGIN,
  GET_PRODUTOS_SUCCESS,
  GET_PRODUTOS_ERROR,
  GET_SINGLE_PRODUTOS_BEGIN,
  GET_SINGLE_PRODUTOS_SUCCESS,
  GET_SINGLE_PRODUTOS_ERROR,
} from '../actions'

const produtos_reducer = (state, action) => {
  if (action.type === SIDEBAR_OPEN) {
    return { ...state, isSidebarOpen: true }
  }
  if (action.type === SIDEBAR_CLOSE) {
    return { ...state, isSidebarOpen: false }
  }
  if (action.type === GET_PRODUTOS_BEGIN) {
    return { ...state, produtos_loading: true }
  }
  if (action.type === GET_PRODUTOS_SUCCESS) {
    const featured_produtos = action.payload.filter(
      (produtos) => produtos.featured === true
    )
    return {
      ...state,
      produtos_loading: false,
      produtos: action.payload,
      featured_produtos,
    }
  }
  if (action.type === GET_PRODUTOS_ERROR) {
    return { ...state, produtos_loading: false, produtos_error: true }
  }
  if (action.type === GET_SINGLE_PRODUTOS_BEGIN) {
    return {
      ...state,
      single_produtos_loading: true,
      single_produtos_error: false,
    }
  }
  if (action.type === GET_SINGLE_PRODUTOS_SUCCESS) {
    return {
      ...state,
      single_produtos_loading: false,
      single_produtos: action.payload,
    }
  }
  if (action.type === GET_SINGLE_PRODUTOS_ERROR) {
    return {
      ...state,
      single_produtos_loading: false,
      single_produtos_error: true,
    }
  }
  throw new Error(`No Matching "${action.type}" - action type`)
}

export default produtos_reducer
